import { Message } from "../../types/types";
import { updateLinksToOpenInNewTabs } from "../../utils/product/updateLinksToOpenInNewTab";
import { MessageWithCategoryAndType } from "../../utils/product/getPromoMessaging";

const lineBreakTags = ["<br>", "<br/>"];

export const cleanPromoDescription = (promotion: Message) => {
  let cleanDescription = removeTitleFromDescription(promotion);
  cleanDescription = removePrecedingLineBreaks(cleanDescription);
  return cleanDescription;
};

export const removeTitleFromDescription = (promotion: Message) => {
  const cleanTitle = promotion.title.trim();

  if (!promotion.description) return null;

  let cleanDescription = promotion.description?.replace(
    // nosemgrep
    `<p><strong>${cleanTitle}</strong></p>`,
    "",
  );

  cleanDescription = cleanDescription.replace(
    // nosemgrep
    `<strong>${cleanTitle}</strong>`,
    "",
  );

  // nosemgrep
  cleanDescription = cleanDescription.replace(`<p>${cleanTitle}</p>`, "");
  cleanDescription = cleanDescription.replace(`${cleanTitle}`, "");
  return cleanDescription.trim();
};

export const removePrecedingLineBreaks = (
  description: string | null | undefined,
) => {
  if (!description) return null;

  lineBreakTags.map((lineBreakTag) => {
    while (description?.startsWith(lineBreakTag)) {
      description = description?.replace(lineBreakTag, "").trim();
    }
  });
  return description;
};

type cleanedPromoMessage = {
  description: string | undefined;
  terms: string | undefined;
};
export const getCleanedPromoDescription = (
  isVersionFour: boolean,
  promotion: MessageWithCategoryAndType,
): cleanedPromoMessage => {
  const descriptionWithTitleFormatting = isVersionFour
    ? promotion.description
    : removeTitleFromDescription(promotion);
  const descriptionWithoutLineBreaks = removePrecedingLineBreaks(
    descriptionWithTitleFormatting,
  );
  const updatedLinksDescription = updateLinksToOpenInNewTabs(
    descriptionWithoutLineBreaks,
  );

  const [description, terms] = updatedLinksDescription.split(
    "<strong>Terms and conditions</strong>",
  );
  return {
    description,
    terms,
  };
};
